import {NEUTRAL_PLAYER_ID} from '../../constants/players';
import {findUnitSkinOwnerPlayer} from './findUnitSkinOwnerPlayer';

/**
 * Положен ли отряду особый образ его фракции (а не общий силуэт): образ
 * открыт у игрока, которому отряд принадлежал изначально.
 *
 * Единое правило для картинки отряда на поле (HexGridRenderer.resolveUnitImageKey)
 * и для оружия в анимации удара ближнего боя (playMeleeAnimation): отряд без
 * образа фракции нарисован общим силуэтом — и бьет стандартным мечом.
 *
 * Решает ИСХОДНЫЙ владелец, а не текущий: переманенный Суккубом отряд
 * сохраняет образ прежнего хозяина. Нейтральные отряды (в том числе
 * переманенные) рисуются своим набором иконок — образа фракции у них нет.
 *
 * Витрина главного меню показывает особые образы у всех отрядов игроков, что
 * бы ни было открыто у них самих (isEverySkinShown): и картинка, и оружие
 * там — фракционные.
 *
 * @param {Object} unit
 * @param {Array} players — все игроки партии
 * @param {Object} [options]
 * @param {boolean} [options.isEverySkinShown] — образы показаны у всех
 *   отрядов игроков (витрина главного меню)
 * @returns {boolean}
 */
export const checkIfUnitHasFactionSkin = (unit, players, {isEverySkinShown = false} = {}) => {
  if (!unit) {
    return false;
  }
  const originalOwnerId = unit.capturedFromOwnerId ?? unit.ownerId;
  if (originalOwnerId === NEUTRAL_PLAYER_ID) {
    return false;
  }
  if (isEverySkinShown) {
    return true;
  }

  return Boolean(findUnitSkinOwnerPlayer({factionId: unit.factionId, originalOwnerId}, players)?.hasUnitSkin);
};
